import i18n from "../../../../constants/i18n";
import { SUPERVISE_ADMIN_AUDITED_EVENTS_HEADERS } from "../../../../constants/table-custom-headers/Supervisor";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import { getSupervisedEventsStore } from "../../../../stores/supervisor-store/supervised-events-store";

const SupervisedAuditEventsData = withLiteObserverAndTheme(() => {
  const supervisedAuditEvents =
    getSupervisedEventsStore().supervisedAuditEventsOrdered.get();
  return (
    <Et3Table
      columns={SUPERVISE_ADMIN_AUDITED_EVENTS_HEADERS}
      rows={supervisedAuditEvents}
      title={i18n.get("EVENTS_COUNT")}
      shouldBeFlagged={false}
      titleKey={"EVENTS_COUNT"}
    />
  );
});

export default SupervisedAuditEventsData;
